import { getFileUrl } from "@/lib/file.util";
import { CardContent, CardFooter, Card } from "../ui/card";
import { Story } from "@/lib/types/story";
import { Button } from "../ui/button";
import { ArrowRight } from "lucide-react";

export default function StoryCard({ story }: { story: Story }) {
  const personName = story.person
    ? `${story.person.firstName} ${story.person.lastName}`
    : "Anonymous";

  const thumbnail = getFileUrl(story.thumbnail);
  return (
    <Card
      className={`overflow-hidden py-0 gap-0! h-full transition-all bg-white/20 hover:shadow-md duration-300 hover:-translate-y-1 hover:border-primary `}
    >
      <div className="relative">
        <div className="aspect-[3/2] relative overflow-hidden">
          <img
            src={thumbnail}
            alt={story.title}
            className="object-cover object-left w-full h-full"
          />
        </div>
      </div>
      <CardContent className="p-4 pt-3 gap-2 flex flex-col h-full">
        <div className="flex items-center gap-2 text-sm text-gray-500">
          <span className="capitalize">Date</span>
          <span>•</span>
          <span>
            {new Date(story.createdAt).toLocaleDateString("en-US", {
              year: "numeric",
              month: "short",
              day: "numeric",
            })}
          </span>
        </div>
        <h3 className="font-bold text-lg line-clamp-2">{story.title}</h3>
        <p className="text-gray-600 text-sm line-clamp-2 xl:line-clamp-3">
          {story.description}
        </p>
        <CardFooter className="px-0 mt-auto !pt-3 border-t flex justify-between items-center">
          <div className="flex flex-wrap gap-2">
            <Button variant="link" className="rounded-full !px-0">
              <span className="text-primary">Read More</span>
              <ArrowRight className="h-6 w-6 text-primary" />
            </Button>
            {/* <Badge variant="secondary" className="flex items-center gap-1">
                <User className="h-3 w-3" />
                {personName}
              </Badge>
              {story.person?.title && (
                <Badge variant="secondary" className="flex items-center gap-1">
                  {story.person.title}
                </Badge>
              )} */}
          </div>
        </CardFooter>
      </CardContent>
    </Card>
  );
}
